export default "/images/vendor/@coreui/icons/svg/flag/cif-bd.svg?d4c7179ab29c693295800e8b85477fa2";